<template>
  <div>
    <gl-datepicker
      :input-id="id"
      :value="date"
      :show-clear-button="true"
      class="w-100"
      @input="updateDate"
      @clear="updateDate(null)"
    />
    <gl-form-input
      :id="`${id}-time`"
      v-model="time"
      :aria-label="timeLabel"
      type="time"
      class="mt-2"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { GlDatepicker, GlFormInput } from '@gitlab/ui';
import { dateHelper } from '@/utils';

const { toUtcIsoString } = dateHelper;
const TIMEFORMAT = 'HH:mm';

export default {
  name: 'DateTimePicker',
  components: {
    GlDatepicker,
    GlFormInput,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    timeLabel: {
      type: String,
      required: false,
      default: 'Time',
    },
  },
  data: () => ({
    date: null,
    time: dayjs().format(TIMEFORMAT),
  }),
  watch: {
    time() {
      this.emitSelection();
    },
  },
  methods: {
    updateDate(date) {
      this.date = date || null;
      this.emitSelection();
    },
    emitSelection() {
      if (this.date === null && !this.time) {
        this.$emit('input', null);
        return;
      }

      // An entered time applies to today when no date has been picked.
      const [hour, minute] = (this.time || dayjs().format(TIMEFORMAT)).split(':');
      const selected = dayjs(this.date || new Date())
        .hour(Number(hour))
        .minute(Number(minute))
        .second(0)
        .millisecond(0);

      this.$emit('input', toUtcIsoString(selected));
    },
  },
};
</script>

<style></style>
